import { render, staticRenderFns } from "./CarInfo.vue?vue&type=template&id=13f1293b&scoped=true&"
import script from "./CarInfo.vue?vue&type=script&lang=js&"
export * from "./CarInfo.vue?vue&type=script&lang=js&"
import style0 from "./CarInfo.vue?vue&type=style&index=0&id=13f1293b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f1293b",
  null
  
)

export default component.exports